import {ApiV0} from '../../api.v0';
import {RestApiService} from '../../../rest-api.service';
import {BaseCollectionModel} from '@yasc/yasc-material-components';
import {ExcelTemplateCreateReq, ExcelTemplateRes} from '../../../../contracts/v0/cp/excel-template';

export class ApiV0ExcelTemplate {
    segment = '/excelTemplate'

    constructor(v0: ApiV0, private rest: RestApiService) {
        this.segment = v0.segment + this.segment;
    }

    getTemplates(forClass:string){
        return this.rest.get<BaseCollectionModel<ExcelTemplateRes>>(`${this.segment}?forClass=${forClass}`, ExcelTemplateRes);
    }

    createTemplate(createReq:ExcelTemplateCreateReq){
        return this.rest.post<ExcelTemplateCreateReq, ExcelTemplateRes>(`${this.segment}`, ExcelTemplateRes, createReq);
    }
}